import {View, Text, Image} from '@react-pdf/renderer';
import RiskScaleBadges from './RiskScaleBadges';
import styles from '../styles';
import DownArrow from '../../../assets/image/pdf/down_arrow.svg';
import {RISK_LETTER_GROUPS, SCALE_POINTER_POSITION} from '../constants';

function getRiskLabel(item: string): string {
  return (
    RISK_LETTER_GROUPS.find(group => group.items.includes(item))?.label ??
    'نامشخص'
  );
}

const RiskGradeBlock: React.FC<{
  riskGrade: string;
}> = ({riskGrade}) => (
  <View style={styles.riskGradeBlock}>
    <View style={[styles.pointer, {left: SCALE_POINTER_POSITION[riskGrade]}]}>
      <Text style={styles.riskGradeTitle}>{riskGrade}</Text>
      <Text style={styles.riskGradeLabel}>{getRiskLabel(riskGrade)}</Text>
      <Image source={DownArrow} />
    </View>

    <RiskScaleBadges />

    <View style={styles.riskNoteRow}>
      <Text style={styles.riskNoteText}>
        پیش‌بینی میزان خوش حسابی (بازپرداخت مناسب)
      </Text>
    </View>
  </View>
);

export default RiskGradeBlock;
